import { IEmojiGroupList } from '../../../interface';

/**
* Custom big emoji
*/
export const CUSTOM_BIG_EMOJI_URL: string = '';

export const CUSTOM_BIG_EMOJI_GROUP_LIST: IEmojiGroupList = [];

/**
* Custom basic emoji
*/
export const CUSTOM_BASIC_EMOJI_URL: string = '';

export const CUSTOM_BASIC_EMOJI_URL_MAPPING: Record<string, string> = {};
